export default __webpack_public_path__ + "static/media/resume.582aae76.pdf";